import * as React from "react";
import {observer} from "mobx-react";
import type {IDateTimeInputFormat} from "../../../../../widgets/input/datetime/DateTimeInput";
import {DateTimeInput} from "../../../../../widgets/input/datetime/DateTimeInput";

interface IDateParamProps {
	readonly param: string;
	readonly format: IDateTimeInputFormat;
	onChange(value: string): void;
}

@observer
export class DateParam extends React.Component<IDateParamProps> {
	public override render() {
		const {param, format, onChange} = this.props;

		return (
			<DateTimeInput
				value={param}
				defaultValue={param}
				onChange={onChange}
				format={format}
			/>
		);
	}
}
